import React, { Component } from 'react';
import { Icon } from 'antd';
import classNames from 'classnames';

export default class OnboardingStepPanel extends Component {
  onSelect = () => {
    const { index, onSelect } = this.props;
    onSelect(index);
  };

  // Called via panel ref from OnboardingRegistration (eslint cannot see that usage).
  // eslint-disable-next-line react/no-unused-class-component-methods -- focus() used by parent via ref
  focus = () => {
    if (!this.panelRef) return;

    const main = this.panelRef.querySelector('.onboarding-registration-panel-main');
    const firstField =
      main &&
      main.querySelector(
        'input:not([type="hidden"]):not([disabled]), textarea:not([disabled]), select:not([disabled])',
      );

    if (firstField) {
      firstField.focus({ preventScroll: true });
      return;
    }

    const primaryAction = this.panelRef.querySelector(
      '.onboarding-registration-actions .ant-btn-primary:not([disabled])',
    );
    if (primaryAction) {
      primaryAction.focus({ preventScroll: true });
      return;
    }

    if (this.headerRef && !this.headerRef.disabled) {
      this.headerRef.focus({ preventScroll: true });
    }
  };

  render() {
    const { activeStep, children, completedSteps, gateLocked, index, step } = this.props;
    const isActive = !gateLocked && index === activeStep;
    const isComplete = !gateLocked && completedSteps.indexOf(index) >= 0;
    const isLocked =
      gateLocked || (index > activeStep && completedSteps.indexOf(index - 1) < 0);

    return (
      <section
        ref={(panelRef) => {
          this.panelRef = panelRef;
        }}
        className={classNames('onboarding-registration-panel', {
          active: isActive,
          complete: isComplete,
          inactive: !isActive,
        })}
      >
        <button
          ref={(headerRef) => {
            this.headerRef = headerRef;
          }}
          className="onboarding-registration-panel-header"
          type="button"
          onClick={this.onSelect}
          disabled={isLocked}
        >
          <span className="onboarding-registration-panel-icon">
            <Icon type={isComplete ? 'check-circle' : step.icon} />
          </span>
          <span className="onboarding-registration-panel-title">
            <strong>
              {step.title}
              {isComplete && <span className="onboarding-registration-complete-badge">Complete</span>}
            </strong>
            <small>{step.subtitle}</small>
          </span>
          <Icon
            className="onboarding-registration-panel-chevron"
            type={isActive ? 'up' : 'down'}
          />
        </button>

        {children}
      </section>
    );
  }
}
